import {useControllers} from '../../../../common/helpers/react/hooks/useControllers';
import {useEffect} from 'react';

export default function GoToLoginPortal() {
    const auth = useControllers().auth;

    useEffect(() => auth.redirectToLoginPortal());

    return <></>;
}
